import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

import french from '@/language/fr/translation.json';
import english from '@/language/en/translation.json';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: {
          ...french,
        },
      },
      en: {
        translation: {
          ...english,
        },
      },
    },
    lng: 'fr',
    fallbackLng: 'fr',
  });

export default i18n;
